(function () {
  function initBundleCarousel(section) {
    if (!section || section.dataset.braidjoyBundleInitialized === 'true') return;

    var track = section.querySelector('[data-braidjoy-bundle-track]');
    var prev = section.querySelector('[data-braidjoy-bundle-prev]');
    var next = section.querySelector('[data-braidjoy-bundle-next]');

    if (!track || !prev || !next) return;

    section.dataset.braidjoyBundleInitialized = 'true';

    var getScrollAmount = function () {
      var card = track.querySelector('.braidjoy-bundle-carousel__card');
      if (!card) return track.clientWidth;

      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || 0);

      return card.getBoundingClientRect().width + gap;
    };

    var updateButtons = function () {
      var maxScrollLeft = Math.max(0, track.scrollWidth - track.clientWidth - 1);
      var canScroll = maxScrollLeft > 1;

      prev.disabled = !canScroll || track.scrollLeft <= 1;
      next.disabled = !canScroll || track.scrollLeft >= maxScrollLeft;
    };

    prev.addEventListener('click', function () {
      if (prev.disabled) return;

      track.scrollBy({
        left: -getScrollAmount(),
        behavior: 'smooth'
      });
    });

    next.addEventListener('click', function () {
      if (next.disabled) return;

      track.scrollBy({
        left: getScrollAmount(),
        behavior: 'smooth'
      });
    });

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateButtons);
    }, { passive: true });

    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  function initAllBundleCarousels(root) {
    var scope = root || document;
    var sections = scope.matches && scope.matches('[data-braidjoy-bundle-carousel]')
      ? [scope]
      : Array.prototype.slice.call(scope.querySelectorAll('[data-braidjoy-bundle-carousel]'));

    sections.forEach(initBundleCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllBundleCarousels(document);
    });
  } else {
    initAllBundleCarousels(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllBundleCarousels(event.target);
  });
})();
